module.exports = __webpack_public_path__ + "img/uploadexampleNew.31e079f4.png";